import { FormTemplateFieldConditionalRule } from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import { useSkipWidgetLink } from '../../../../../shared/componentsV2/SkipWidgetLink';
import { FieldConditionHelpers } from '../hooks/useFieldConditionHelpers';
import { EditableFormTemplateField } from '../types';
import { ConditionalFieldValuesPicker } from './ConditionalFieldValues/ConditionalFieldValuesPicker';
import { ConditionallyShownFields } from './ConditionallyShownFields';
import { ConditionalOperatorPicker } from './ConditionalOperatorPicker';
import { DeleteConditionalRuleButton } from './DeleteConditionalRuleButton';

const RuleContainer = styled.div`
  padding: 1rem;
  margin: 1rem 0;
  background-color: ${({ theme }) => theme.colors.grayf6};
  border: 1px solid ${({ theme }) => theme.colors.grayeee};
  border-radius: 0.5rem;
`;

const RuleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

type RuleConfigurationProps = {
  fieldsInGroup: EditableFormTemplateField[];
  fieldConditionHelpers: FieldConditionHelpers;
  deleteConditionalRule: () => void;
  ruleName: string;
  triggerField: EditableFormTemplateField;
};

export function RuleConfiguration({
  fieldsInGroup,
  fieldConditionHelpers,
  ruleName,
  triggerField,
  deleteConditionalRule,
}: RuleConfigurationProps) {
  const { SkipLink, SkipLinkTarget } = useSkipWidgetLink();

  const {
    input: { value: conditionalRule },
  } = useField<FormTemplateFieldConditionalRule>(ruleName);

  return (
    <RuleContainer>
      <SkipLink linkText="Skip past this conditional rule" />
      <RuleRow>
        <ConditionalOperatorPicker
          rulePrefix={ruleName}
          triggerField={triggerField}
        />
        <ConditionalFieldValuesPicker
          rulePrefix={ruleName}
          rule={conditionalRule}
          triggerField={triggerField}
        />
      </RuleRow>
      <ConditionallyShownFields
        triggerFieldId={triggerField.id}
        fieldsInGroup={fieldsInGroup}
        fieldConditionHelpers={fieldConditionHelpers}
        rulePrefix={ruleName}
      />
      <DeleteConditionalRuleButton
        deleteConditionalRule={deleteConditionalRule}
      />
      <SkipLinkTarget />
    </RuleContainer>
  );
}
